import { FunctionalComponent } from 'preact'
import Card from '@insided/shared/uikit/Card'
// eslint-disable-next-line import/no-internal-modules
import globals from '@insided/deprecated-utils/globals'
import { LibraryWidgetMetadata } from '@insided/customization'
import classnames from 'classnames'

const FALLBACK_IMG_SRC =
  'https://uploads-eu-west-1.insidedtest.com/test-community/attachment/b094b15f-6fa5-4399-a63a-4b131c570d58.png'

export interface WidgetCardProps {
  idx: number
  widget: LibraryWidgetMetadata
  onWidgetSelected: () => void
  disabled: boolean
}

export const WidgetCard: FunctionalComponent<WidgetCardProps> = ({
  idx,
  onWidgetSelected,
  widget,
  disabled = false
}) => {
  const imageSrc = widget.imageName ? `${globals('basePath')}images/widgets/${widget.imageName}.png` : FALLBACK_IMG_SRC
  return (
    <Card
      title={widget.title}
      metadata={widget.containers.join(' | ')}
      size='M'
      idx={idx}
      customClass={classnames(widget.type, {
        'widgets-library--widget-disabled': disabled
      })}
      isControl
      onClick={onWidgetSelected}
      imageSrc={imageSrc}
      disabled={disabled}
    />
  )
}
